import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import TituloComponent from '../../components/Titulo/TituloComponent';
import { getContaCliente, informarPagamentoConta } from '../../services/api';
import Carregando from '../../components/Carregando/Carregando';

// css
import '../../styles/global.css';
import './PagamentoContaMaquininha.css';
import '../../styles/global.css';


const PagamentoContaMaquininha = () => {
  const navigate = useNavigate();

  const [carregando, setCarregando] = useState(true);
  
  // Pega os dados da sessão diretamente
  const userData = JSON.parse(sessionStorage.getItem('userData')); // Assume que os dados estão armazenados no sessionStorage
  const statusUsuario = userData?.statusUsuario;
  const nomePerfil = userData?.dadosPerfil?.nome;
  const nomeUsuario = userData?.user.name;

  const [isAuthorized, setIsAuthorized] = useState(true);
  const [produtosNaoPagos, setProdutosNaoPagos] = useState([]);
  const [produtosPagos, setProdutosPagos] = useState([]);

  const [formData, setFormData] = useState({
    numeroMesa: "",
    numeroComanda: "",
  });

  // vamos calcular o valor total da conta - tem que ficar aqui fora
  const valorTotalConta = produtosNaoPagos.reduce((total, produto) => {
    return total + parseFloat(produto.preco_produto || 0);
  }, 0);


  useEffect(() => {
    console.log('Entou no useEffect do Pagamento Conta Maquininha...');
    // Verifica se o usuário tem o perfil correto e está logado
    if (!userData || userData.dadosPerfil?.nome !== 'BAR GARCON' || userData.statusUsuario !== 'logado') {
      console.log(' !!!! Perfil não autorizado ou usuário não logado. Redirecionando...');
      setIsAuthorized(false); // Atualiza o estado de autorização
      setCarregando(false);
      navigate('/area-restrita'); // Redireciona para a página de login ou área restrita
    } else {
      console.log('--- PAGINA PAGAMENTO CONTA COM MAQUININHA ---');
      console.log('Dados completos do usuário:', userData);
      console.log('Status do usuário:', statusUsuario);
      console.log('Perfil do usuário:', nomePerfil);
      setCarregando(false);
    }
  }, [userData, statusUsuario, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    setCarregando(true);
    console.log('entrou no handleSubmit...');
    e.preventDefault();

    const contaCliente = null;

    console.log('formData: ');
    console.log(formData);

    // Aqui quer dizer que o usuário deseja buscar a conta do cliente
    try {
      const response = await getContaCliente(userData, formData);
      console.log('Response recebido:', response);

      console.log('conta do cliente: ');
      console.log(response);

      const produtosNaoPagosAtualizados = response.arrayProdutosNaoPagos;
      setProdutosNaoPagos(produtosNaoPagosAtualizados);

      const produtosPagosAtualizados = response.arrayProdutosPagos;
      setProdutosPagos(produtosPagosAtualizados);

      console.log('Produtos não pagos: ');
      console.log(produtosNaoPagos);
      setCarregando(false);

    } catch (error) {
      console.error('Erro ao receber a conta do cliente:', error);
      // Exibe a mensagem de erro vinda da API
      const errorMessage = error.response?.data?.message || 'Erro ao receber a conta do cliente.';
      alert(errorMessage);
      setCarregando(false);
    }
  };

  // se o usuário não estiver autorizado
  if (!isAuthorized) {
    return <div>Redirecionando...</div>;
  }

  const handleInformarPagamentoConta = async () => {
    setCarregando(true);
    console.log('--- ============== ---');
    console.log('Entrou em handleInformarPagamentoConta em PagamentoContaMaquininha.js');

    try {
      const dados = await informarPagamentoConta(produtosNaoPagos);

      console.log('!!!!!! Dados recebidos do checkout: ');
      console.log(dados);

      navigate('/bar-garcon');
      setCarregando(false);

    } catch (error) {
      setCarregando(false);
      console.error('Erro ao informar o pagamento da conta:', error);
    }    

  }

  if (carregando) {
    return <Carregando />;
  }

  return (
    <div autoFocus className="bar-gerente-container">
        <TituloComponent />
        <h1 className="sub-titulo">Área do Garçon</h1>
        
        <form onSubmit={handleSubmit}>
          <h2 className="form-title">Informar pagamento de conta</h2>

          {/* Quadro de Dados Pessoais */}
          <div className="form-section">
            <h3 className="section-title">Dados do Cliente</h3>
            
            <div className="form-group">
              <label htmlFor="nomeCompleto">Número da mesa</label>
              <input
                type="text"
                id="numeroMesa"
                name="numeroMesa"
                className="form-control"
                placeholder="Quitar toda a conta"
                value={formData.numeroMesa}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="nomeCompleto">Número da comanda</label>
              <input
                type="text"
                id="numeroComanda"
                name="numeroComanda"
                className="form-control"
                placeholder="Quitar apenas a comanda"
                value={formData.numeroComanda}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-section">
            <p>
              Se o cliente desejar pagar apenas a sua conta, informe o número da comanda.
            </p>
            <p>
              Se o cliente desejar pagar a conta total da mesa, informe o número da mesa.
            </p>
          </div>

          <button type="submit" className="btn-primary">
            Buscar
          </button>

        </form>

        {
          valorTotalConta > 0 
          ?
            <div className="box-conta">
              <h3 className="section-title">Conta: </h3>
              {
                produtosNaoPagos.map((produto, index) => (              
                  <div key={index} className="conta-listagem-produtos">
                    <p className="conta-produto-nome">{produto.nome_produto}: </p>
                    <p className="conta-produto-preco"> R$ {produto.preco_produto}</p>
                  </div>
                ))
              }
              <div className="conta-listagem-produtos">
                <p className="conta-total"> R$ {valorTotalConta.toFixed(2)}</p>
              </div>
              <div className="conta-botao-pagar">
                <p > 
                  <button className="btn-primary"
                      onClick={() => {
                          const confirmacao = window.confirm("Tem certeza que deseja confirmar o pagamento da conta?");
                          if (confirmacao) {
                            handleInformarPagamentoConta();
                          }
                      }}
                  >
                    Informar pagamento
                  </button>
                </p>            
              </div>          
            </div>
          :
          <div className="box-conta">
              <h3 className="section-title">Nenhuma conta a ser paga! </h3>
            
          </div>
        }



    </div>
  );
};

export default PagamentoContaMaquininha;
